import React, { useState, useEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));


function AboutUs() {

  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const visionMissionData = [
    {
      icon: imgs['compass-svgrepo-com.svg'],
      title: 'VISION',
      text: 'A humanity grounded in consciousness, justice, and compassion — where transformed individuals create transformed systems.'
    },
    {
      icon: imgs['heart-alt-svgrepo-com.svg'],
      title: 'MISSION',
      text: 'Our mission is to enable inner transformation for systems change. We support initiatives that awaken consciousness, restore human dignity, and address the root causes of injustice — so individuals and communities can evolve toward a more just and compassionate world.'
    }
  ];

  const valuesData = [
    {
      title: 'ONENESS',
      text: 'Remember that We are One.'
    },
    {
      title: 'INTEGRITY',
      text: 'We act with honesty, responsibility, and respect—always guided by what is right.'
    },
    {
      title: 'HUMILITY',
      text: 'We honor our roots, recognize those who came before us, and stay grounded in gratitude.'
    },
    {
      title: 'SERVICE',
      text: 'We believe our purpose is to be of service to others and to uplift our communities.'
    },
    {
      title: 'COURAGE',
      text: 'We embrace challenges, speak truthfully, and take actions that align with our values.'
    }
  ];

  const affiliationsData = [
    {
      logo: 'image 2200 (1).png',
      isSpecial: true,
      bgColor: '#00738E',
      text: 'APC is a membership platform for Asian philanthropists to jointly grow the impact of their philanthropy and to catalyse an Asian philanthropy.',
      url: 'https://asiaphilanthropycircle.org/'
    },
    {
      logo: 'image 2206.png',
      isSpecial: true,
      bgColor: '#354402',
      text: 'Nexus aims to educate, connect, inspire, and activate the next generation of exceptional social innovators, philanthropists and impact investors globally.',
      url: 'https://nexusglobal.org/'
    },
    {
      logo: 'legacyventure 1.png',
      isSpecial: true,
      bgColor: '#1A377D',
      text: 'Legacy Venture is a Fund of Venture Capital funds that manages investment funds. Their clients are investors who direct all investment proceeds, both principal and gains, to charitable organizations.',
      url: 'https://www.legacyventure.com/'
    },
    {
      logo: 'image 2207.png',
      isSpecial: false,
      bgColor: '#091F40',
      text: 'TBN Asia is an ecosystem that brings together social entrepreneurs, impact investors, domain experts and others to support and resource sustainable social impact businesses in Southeast Asia.',
      url: 'https://www.tbn.asia/'
    },
    {
      logo: 'image 2208.png',
      isSpecial: false,
      bgColor: '#02256D',
      text: 'Rotary is a global network of 1.4 million neighbors, friends, leaders, and problem-solvers who see a world where people unite and take action to create lasting change – across the globe, in our communities, and in ourselves.',
      url: 'https://www.rotary.org/en'
    },
    {
      logo: 'image 2209.png',
      isSpecial: false,
      bgColor: '#00283E',
      text: 'Catalyst 2030 is a fast-growing global movement of people and organisations committed to advancing the UN Sustainable Development Goals (SDGS) by 2030.',
      url: 'https://catalyst2030.net/'
    }
  ];

  return (
    <>
      <div className='mt-14 md:mt-24 relative'>
        <img className='hidden md:block w-full' src={imgs['Group 3013.png']}/>
        <img className='md:hidden block w-full' src={imgs['Group 3016.png']}/>

        <div
          className='w-[227px] md:w-[600px] text-center absolute text-lg md:text-5xl font-bold text-white z-1 md:leading-[1.2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          {
            locale === 'en' ? 'Inspiring future generations to create positive change' :
              'Truyền cảm hứng cho các thế hệ tương lai kiến tạo những thay đổi tích cực'
          }
        </div>
      </div>

      {/*about us*/}
      <div className='bg-white py-4 md:py-10 px-5 md:px-[7.5%]'>
        <div className='text-center mb-2 md:mb-3'>
          <h2 className='text-sm md:text-xl font-bold uppercase'>
            {fm('ABOUT US')}
          </h2>
        </div>
        <div className='max-w-[90%] md:max-w-2xl mx-auto'>
          <p className='text-base text-black md:text-2xl leading-relaxed text-center'>
            {fm('We support the inner and outer work of transformation—cultivating consciousness within individuals and institutions to address the root causes of injustice and advance dignity, justice, and well-being for all of life.')}
          </p>
        </div>
      </div>

      {/*Who We Are*/}
      <div className='block md:hidden'>
        <img src={imgs['image 2324.png']} className='w-full'/>
      </div>
      <div className='bg-white py-8 md:py-20 px-8 md:px-[7.5%]'>
        <h2 className='text-xl md:text-3xl font-bold mb-2 md:mb-4 text-black'>
          {fm('Who We Are')}
        </h2>
        <div className='flex flex-col md:flex-row gap-8 md:gap-12 items-start'>
          {/* Text Section - Left */}
          <div className='flex-1 md:flex-[2]'>

            <div className='space-y-4 md:space-y-6'>
              <p className='text-base md:text-lg leading-relaxed text-black'>
                {fm('The Nguyễn-Phương Family believes in paying it forward by working with social impact organizations and changemakers. We collaborate with partners around the world working to provide education, strengthen communities and support systems changing solutions. We aim to leave the world a little better than we found it.')}
              </p>
              <p className='text-base md:text-lg leading-relaxed text-black'>
                {fm('We do our work through private philanthropy with historical roots in Vietnam and a global vision. Our work is made possible through the ongoing engagement of the Nguyễn-Phương Family and our partners.')}
              </p>
            </div>
          </div>
          {/* Image Section - Right */}
          <div className='flex-1 md:flex-[1] w-full md:w-auto hidden md:block'>
            <img
              src={imgs['image 2323.png']}
              alt="Who We Are"
              className='w-full h-auto object-cover'
            />
          </div>
        </div>
      </div>

      {/*VISION MISSION*/}
      <div className='bg-white py-2 md:py-5 px-5 md:px-[7.5%]'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mx-auto'>
          {visionMissionData.map((item, index) => (
            <div
              key={index}
              className='min-h-[188px] bg-[#F5F4EE] rounded-2xl p-4 md:p-8 relative overflow-hidden'
            >
              {/* Background graphic */}
              <div className='absolute top-0 right-0 w-2/5 md:w-1/3 h-full'>
                <img
                  src={imgs['Group 3014.png']}
                  alt=""
                  className='w-full h-full object-cover'
                />
              </div>

              {/* Content */}
              <div className='relative z-10'>
                {/* Icon */}
                <div className='mb-2 md:mb-6'>
                  <img
                    src={item.icon}
                    alt={item.title}
                    className='w-[40px] md:w-[auto]'
                  />
                </div>

                {/* Title */}
                <h3 className='text-xl md:text-2xl font-bold uppercase mb-2 md:mb-6 text-black'>
                  {fm(item.title)}
                </h3>

                {/* Text */}
                <p className='max-w-[240px] md:max-w-[435px] text-[11px] md:text-base leading-relaxed text-black'>
                  {fm(item.text)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/*Our Values*/}
      <div className='bg-[#F5F4EE] py-10 md:py-20 px-5 md:px-[7.5%]'>
        <div className='mx-auto'>
          {/* Header Section */}
          <div className='text-center mb-8 md:mb-12'>
            <div className='text-xs font-bold md:text-sm uppercase mb-2 md:mb-4 text-black'>
              {fm('Our Values')}
            </div>
            <h2 className='max-w-[740px] mx-auto text-2xl md:text-5xl font-bold mb-4 md:mb-6 text-black leading-tight'>
              {fm('Oneness, Integrity, Humility, Service and Courage')}
            </h2>
            <p className='text-sm md:text-2xl text-black max-w-3xl mx-auto'>
              {fm('Our values guide our actions, shape how we approach philanthropy, engage with partners, and contribute to positive change.')}
            </p>
          </div>

          {/* Values Cards Grid */}
          <div className='hidden md:block'>
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-20'>
              {/* First 3 cards */}
              {valuesData.slice(0, 3).map((value, index) => (
                <div
                  key={index}
                  className='bg-white rounded-lg p-6 md:p-4 shadow-sm'
                >
                  <h3 className='text-lg md:text-lg font-bold text-center uppercase mb-3 md:mb-2 '>
                    {fm(value.title)}
                  </h3>
                  <p className='text-sm md:text-base  text-center leading-relaxed '>
                    {fm(value.text)}
                  </p>
                </div>
              ))}
            </div>
            <div className='grid mt-5 grid-cols-1 md:grid-cols-2 gap-4 md:gap-20 w-[70%] mx-auto'>
              {/* Last 2 cards - centered */}
              {valuesData.slice(3, 5).map((value, index) => (
                <div
                  key={index + 3}
                  className='bg-white rounded-lg p-6 md:p-4 shadow-sm'
                >
                  <h3 className='text-lg md:text-lg font-bold  text-center uppercase mb-3 md:mb-2'>
                    {fm(value.title)}
                  </h3>
                  <p className='text-sm md:text-base  text-center leading-relaxed'>
                    {fm(value.text)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className='block md:hidden mx-auto w-[90%]'>
            {valuesData.map((value, index) => (
              <div
                key={index}
              >
                <h3 className='text-sm font-bold uppercase mb-1'>
                  {fm(value.title)}
                </h3>
                <p className='text-sm md:text-base  leading-relaxed'>
                  {fm(value.text)}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/*Behind the Logo*/}
      <div className='flex flex-col md:flex-row'>
        {/* Left Image Section */}
        <div className='flex-1 min-w-[50%] relative'>
          <img
            src={imgs['Group 3015 (1).png']}
            alt="Rice terraces"
            className='w-full h-full object-cover'
          />
        </div>

        {/* Right Text Panel */}
        <div className='flex-1 bg-[#354402] p-8 md:py-12 md:px-16 flex flex-col justify-center text-white'>
          <h2 className='text-2xl md:text-4xl font-bold mb-3 md:mb-8 text-white'>
            {fm('Behind the Logo')}
          </h2>

          <div className='space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed'>
            <p>
              {locale === 'en' ? (
                <>
                  <b>Rice terraces</b> (Ruộng bậc thang) are a symbol of the masterpiece of nature blended with the
                  creativity, patience and collaboration of humans. Rice is a key source of life for all people -
                  regardless of their background.
                </>
              ) : (
                <>
                  <b>Ruộng bậc thang</b> là biểu tượng của kiệt tác của thiên nhiên hòa quyện với sự sáng tạo, sự kiên
                  nhẫn và hợp tác của con người. Lúa gạo là nguồn sống chủ yếu của tất cả mọi người - bất kể hoàn cảnh
                  xuất thân.
                </>
              )}
            </p>

            <p>
              {locale === 'en' ? (
                <>
                  The font used in our logo is <b>Ven</b>, a typeface created by Dat Trong Do. This font was inspired by
                  the Ao Dai and Vietnamese conical hat - to represent the beauty, gracefulness and mysteriousness of
                  Vietnam.
                </>
              ) : (
                <>
                  Phông chữ được sử dụng trong logo của chúng tôi là <b>Ven</b>, một kiểu chữ được tạo bởi Đạt Trọng Đỗ.
                  Phông chữ này được lấy cảm hứng từ áo dài và nón lá Việt Nam - để thể hiện vẻ đẹp, sự duyên dáng và
                  huyền bí của Việt Nam.
                </>
              )}
            </p>
          </div>
        </div>
      </div>

      {/*Our Affiliations*/}
      <div className='bg-white py-10 md:py-14 px-5 md:px-[7.5%]'>
        {/* Header Section */}
        <div className='md:mb-6'>
          <h2 className='text-2xl md:text-4xl font-bold mb-4 md:mb-2 text-black text-center md:text-left'>
            {fm('Our Affiliations')}
          </h2>
          <p className='text-base md:text-xl text-black text-center md:text-left max-w-3xl'>
            {fm('We are affiliated with the following networks:')}
          </p>
        </div>

        {/* Desktop Grid */}
        <div className='hidden md:grid grid-cols-3 gap-5 md:gap-8 mx-auto'>
          {affiliationsData.map((affiliation, index) => (
            <div
              key={index}
              className='flex flex-col rounded-2xl p-5 md:p-6 relative'
              style={{backgroundColor: affiliation.bgColor}}
            >
              {/* Logo */}
              <div className='h-16 md:h-20 flex items-center mb-4'>
                <img
                  src={imgs[affiliation.logo]}
                  alt=""
                  className={`${affiliation.isSpecial ? 'max-h-16 md:max-h-20 h-auto' : 'h-10 md:h-14'}`}
                />
              </div>

              {/* Text Content */}
              <div className='flex-1 text-white text-sm md:text-base leading-relaxed relative pb-8'>
                <p>{fm(affiliation.text)}</p>
                {/* Arrow Icon */}
                <span
                  onClick={() => window.open(affiliation.url)}
                  className='absolute bottom-0 right-0 cursor-pointer'
                >
                  <img
                    src={imgs['arrow-down-right-svgrepo-com 1.svg']}
                    alt="Learn more"
                    className='w-5 h-5 md:w-6 md:h-6'
                  />
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Carousel - 2 items per slide */}
        <div className='block md:hidden relative'>
          <div
            className='overflow-hidden relative'
            onTouchStart={(e) => touchStartX.current = e.touches[0].clientX}
            onTouchMove={(e) => touchEndX.current = e.touches[0].clientX}
            onTouchEnd={() => {
              if (!touchStartX.current || !touchEndX.current) return;
              const distance = touchStartX.current - touchEndX.current;
              const isLeftSwipe = distance > 50;
              const isRightSwipe = distance < -50;
              const totalPairs = Math.ceil(affiliationsData.length / 2);

              if (isLeftSwipe && currentSlide < totalPairs - 1) {
                setCurrentSlide(currentSlide + 1);
              }
              if (isRightSwipe && currentSlide > 0) {
                setCurrentSlide(currentSlide - 1);
              }

              touchStartX.current = null;
              touchEndX.current = null;
            }}
          >
            <div
              className='flex transition-transform duration-300 ease-in-out'
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {/* Render pairs of 2 items */}
              {Array.from({ length: Math.ceil(affiliationsData.length / 2) }).map((_, pairIndex) => (
                <div key={pairIndex} className='flex-shrink-0 w-full flex gap-4'>
                  {affiliationsData.slice(pairIndex * 2, pairIndex * 2 + 2).map((affiliation, itemIndex) => (
                    <div
                      key={pairIndex * 2 + itemIndex}
                      className='flex-1 flex flex-col rounded-2xl p-4 relative'
                      style={{backgroundColor: affiliation.bgColor}}
                    >
                      {/* Logo */}
                      <div className='h-16 flex items-center mb-3'>
                        <img
                          src={imgs[affiliation.logo]}
                          alt=""
                          className={`${affiliation.isSpecial ? 'max-h-16 h-auto' : 'h-12'}`}
                        />
                      </div>

                      {/* Text Content */}
                      <div className='flex-1 text-white text-xs leading-relaxed relative pb-6'>
                        <p>{fm(affiliation.text)}</p>
                        {/* Arrow Icon */}
                        <span
                          onClick={() => window.open(affiliation.url)}
                          className='absolute bottom-0 right-0 cursor-pointer'
                        >
                          <img
                            src={imgs['arrow-down-right-svgrepo-com 1.svg']}
                            alt="Learn more"
                            className='w-5 h-5'
                          />
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Pagination Dots - 3 dots for 3 pairs */}
          <div className='flex justify-center gap-2 mt-6'>
            {Array.from({ length: Math.ceil(affiliationsData.length / 2) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-2 rounded-full transition-all ${
                  index === currentSlide ? 'bg-[#354402] w-8' : 'bg-gray-300 w-2'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

    </>
  );
}

export default AboutUs;
